{
  "de": {
    "nav": "Für Firmen",
    "eyebrow": "FÜR UNTERNEHMEN · MANAGEMENT · TEAMS · THALWIL",
    "title": "Leadership & Teambuilding auf der Matte.",
    "intro": "Gemeinsam Neues wagen. Unter Druck klar bleiben. Verantwortung füreinander übernehmen. Brazilian Jiu-Jitsu macht Zusammenarbeit unmittelbar erlebbar – für Führungskräfte und Teams, die ihren Berufsalltag aus einer neuen Perspektive betrachten möchten.",
    "ideaTitle": "Raus aus der Routine. Rein ins gemeinsame Lernen.",
    "idea": "Auf der Matte hilft ein Titel nicht weiter. Gefragt sind Aufmerksamkeit, klare Absprachen und die Bereitschaft, wieder Anfänger zu sein. In angeleiteten Partnerübungen erleben Sie, wie Sie auf ungewohnte Situationen reagieren – und wie Sie gemeinsam Lösungen finden. Anschliessend reflektieren wir, was sich daraus für die Zusammenarbeit im Unternehmen ableiten lässt.",
    "goalsTitle": "Was Ihr Team mitnehmen kann",
    "goals": [
      [
        "Vertrauen & Verantwortung",
        "Partnerübungen gelingen, wenn beide aufeinander achten, Grenzen respektieren und das Tempo abstimmen. Im Business: Erwartungen klären, zuhören und Verantwortung für das gemeinsame Ergebnis übernehmen."
      ],
      [
        "Klarheit unter Druck",
        "In einer ungewohnten Position innehalten, die Situation lesen und einen nächsten Schritt wählen. Im Management: automatische Reaktionen hinterfragen und trotz Zeitdruck bewusst entscheiden."
      ],
      [
        "Anpassungsfähigkeit & Strategie",
        "Wenn ein Ansatz nicht funktioniert, verändern wir Winkel, Timing oder Vorgehen. Im Business: Annahmen prüfen, Feedback nutzen und den Plan an die Situation anpassen."
      ],
      [
        "Lernkultur & Selbstführung",
        "Etwas ausprobieren, an Grenzen stossen, nachfragen und erneut beginnen. Für Führungskräfte: offen mit Nichtwissen umgehen und Lernen durch das eigene Verhalten vorleben."
      ]
    ],
    "focusTitle": "Präsenz statt Autopilot.",
    "focus": "Eine Partnerübung verlangt Aufmerksamkeit für das, was gerade passiert. Wahrnehmen, Impulse bremsen und flexibel reagieren werden zu konkreten Aufgaben. In der Reflexion fragen wir: Was lenkt mich ab? Wann werde ich hektisch? Was hilft mir, wieder bewusst zu handeln?",
    "transferTitle": "Die Erfahrung ist der Anfang. Der Transfer gehört dazu.",
    "steps": [
      [
        "Ziele abstimmen",
        "Wir besprechen Anlass, Teamgrösse, verfügbare Zeit und Ihre Fragestellungen – vom gemeinsamen Teamevent bis zum Workshop für Führungskräfte."
      ],
      [
        "Gemeinsam erleben",
        "Einführung und angeleitete BJJ-Partnerübungen, angepasst an die Gruppe. Vorkenntnisse sind nicht nötig; Intensität und körperlicher Kontakt werden vorab besprochen. Teilnahme an einzelnen Übungen ist freiwillig."
      ],
      [
        "Reflektieren & übertragen",
        "Wir besprechen Beobachtungen aus den Übungen und formulieren konkrete Impulse für den Alltag: etwa klarere Absprachen, bewusste Pausen vor Entscheidungen oder einen offeneren Umgang mit Feedback."
      ]
    ],
    "audience": "Für Managementteams, Führungskräfte, Projektteams und Unternehmen, die Zusammenarbeit durch eine gemeinsame Erfahrung vertiefen möchten.",
    "safety": "Respekt und persönliche Grenzen gehören zum Format. Ein vereinbartes Stoppsignal beendet die Übung sofort. Es geht um gemeinsames Lernen; niemand muss sich in einem Wettkampf beweisen.",
    "ctaTitle": "Ihr Team. Ihre Ziele. Ihr Paket.",
    "ctaText": "Ausschliesslich im Silver Coast Dojo in Thalwil: Wir stimmen Inhalt, Dauer und Ablauf individuell mit Ihnen ab. Teilen Sie uns Teamgrösse, Wunschtermin und Ziele mit – Sie erhalten ein massgeschneidertes Angebot auf Anfrage.",
    "cta": "Firmenangebot anfragen",
    "mailNote": "Öffnet Ihr E-Mail-Programm mit einer vorbereiteten Anfrage.",
    "subject": "Firmenanfrage: Leadership & Teambuilding",
    "body": "Guten Tag Tiago-Team,\n\nWir interessieren uns für ein individuelles Firmenangebot.\n\nUnternehmen:\nKontaktperson:\nTeamgrösse:\nStandort: Silver Coast Dojo, Thalwil\nWunschtermin und verfügbare Zeit:\nZiele / Anlass:\nBesondere Bedürfnisse:\n\nBitte kontaktieren Sie uns für die Abstimmung eines massgeschneiderten Pakets."
  },
  "en": {
    "nav": "Corporate",
    "eyebrow": "CORPORATE · LEADERSHIP · TEAMS · THALWIL",
    "title": "Leadership & team building on the mat.",
    "intro": "Try something new together. Stay composed under pressure. Take responsibility for one another. Brazilian Jiu-Jitsu offers a hands-on experience of collaboration for leaders and teams looking for a fresh perspective on working together.",
    "ideaTitle": "Step out of your routine. Learn together.",
    "idea": "On the mat, a job title only takes you so far. What matters is attention, clear communication and a willingness to be a beginner again. Guided partner exercises let you explore how you respond to unfamiliar situations and find solutions together. We then reflect on what these experiences can mean for collaboration at work.",
    "goalsTitle": "What your team can take away",
    "goals": [
      [
        "Trust & responsibility",
        "Partner exercises work when both people pay attention, respect boundaries and agree on the pace. At work: clarify expectations, listen and take responsibility for shared outcomes."
      ],
      [
        "Clarity under pressure",
        "Pause in an unfamiliar position, assess the situation and choose a next step. In leadership: question automatic reactions and make deliberate decisions under time pressure."
      ],
      [
        "Adaptability & strategy",
        "When an approach does not work, adjust the angle, timing or method. At work: test assumptions, use feedback and adapt your plan to the situation."
      ],
      [
        "Learning culture & self-leadership",
        "Try, reach a limit, ask questions and start again. For leaders: be open about what you do not know and model a willingness to learn."
      ]
    ],
    "focusTitle": "Present, rather than on autopilot.",
    "focus": "A partner exercise asks you to pay attention to what is happening now. Observing, pausing an impulse and responding flexibly become practical tasks. During reflection, we ask: What distracts me? When do I rush? What helps me respond deliberately again?",
    "transferTitle": "The experience is the starting point. Reflection brings it to work.",
    "steps": [
      [
        "Define your goals",
        "We discuss the occasion, group size, available time and your priorities, from a shared team event to a workshop for managers."
      ],
      [
        "Explore together",
        "An introduction and guided BJJ partner exercises adapted to the group. No previous experience is needed; intensity and physical contact are discussed in advance. Participation in each exercise is voluntary."
      ],
      [
        "Reflect & apply",
        "We discuss observations from the exercises and identify practical ideas for work, such as clearer agreements, a deliberate pause before decisions or a more open approach to feedback."
      ]
    ],
    "audience": "For management teams, leaders, project teams and organisations that want to deepen collaboration through a shared experience.",
    "safety": "Respect and personal boundaries are part of the format. An agreed stop signal ends an exercise immediately. The focus is shared learning; nobody has to prove themselves in a competition.",
    "ctaTitle": "Your team. Your goals. Your package.",
    "ctaText": "Exclusively at our Silver Coast Dojo in Thalwil: content, duration and format are tailored to your needs. Tell us your group size, preferred date and goals, and we will prepare an individual proposal on request.",
    "cta": "Enquire about a corporate package",
    "mailNote": "Opens your email app with a prepared enquiry.",
    "subject": "Corporate enquiry: Leadership & team building",
    "body": "Hello Tiago team,\n\nWe are interested in a tailored corporate package.\n\nCompany:\nContact person:\nGroup size:\nLocation: Silver Coast Dojo, Thalwil\nPreferred date and available time:\nGoals / occasion:\nSpecific requirements:\n\nPlease contact us to discuss a tailored package."
  }
}
